import {createDecorator} from 'vue-class-component'
import _ from 'lodash';

export const Debounce = (ms: number) => createDecorator((options, key) => {
  // Keep the original method for later.
  const originalMethod = options.methods![key]

  // Wrap the method with the logging logic.
  options.methods![key] = _.debounce(function wrapperMethod(...args) {
    // Print a log.
    console.log(`Invoked: ${key}(`, ...args, ')')

    // Invoke the original method.
    // @ts-ignore
    originalMethod.apply(this, args)
  }, ms);
});